import { Edit2, Link, Share2, Tag, Trash2 } from "react-feather";
import { H4, LI, P, UL } from "../../../../../AbstractElements";
import { Href } from "../../../../../Constants/Constants";
import { FavDescriptionDataProp } from "../../../../../Types/BookmarkType";

const FavDescriptionData:React.FC<FavDescriptionDataProp> = ({ myBookData}) => {
  return (
    <div className="desciption-data">
      <div className="title-bookmark">
        <H4 className="title_0">{myBookData.title}</H4>
        <P className="weburl_0">{myBookData.website_url}</P>
        <div className="hover-block">
          <UL className="simple-list flex-row">
            <LI><a href={Href}><Edit2 /></a></LI>
            <LI><a href={Href}><Link /></a></LI>
            <LI><a href={Href}><Share2 /></a></LI>
            <LI><a href={Href}><Trash2 /></a></LI>
            <LI className="text-end"><a href={Href}><Tag /></a></LI>
          </UL>
        </div>
        <div className="content-general">
          <P className="desc_0">{myBookData.desc}</P>
          <span className="collection_0">{myBookData.collection}</span>
        </div>
      </div>
    </div>
  );
};

export default FavDescriptionData;
